export const config = {
    apiKey: "AIzaSyBSLHMU9n7lcrfn_DXWgwrKH271EOgX-kM",
    authDomain: "swipe-app-ondernemers.firebaseapp.com",
    projectId: "swipe-app-ondernemers",
    storageBucket: "swipe-app-ondernemers.appspot.com",
    messagingSenderId: "1098823590972",
    appId: "1:1098823590972:web:5971bfc11413a067d00f39",
};
